import { render, staticRenderFns } from "./BuyOrderList.vue?vue&type=template&id=1f97577c&"
import script from "./BuyOrderList.vue?vue&type=script&lang=js&"
export * from "./BuyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrderList.vue?vue&type=style&index=0&id=1f97577c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports